/**
 * Production "Produkty" category filter tabs. Every category group is
 * already rendered server-side (see product-catalog.php) — clicking a tab
 * just shows/hides groups client-side rather than re-querying.
 */
export function initProductFilters() {
	const tabs = document.querySelectorAll( '[data-filter-tab]' );
	const groups = document.querySelectorAll( '[data-filter-group]' );

	if ( ! tabs.length || ! groups.length ) {
		return;
	}

	tabs.forEach( ( tab ) => {
		tab.addEventListener( 'click', () => {
			const filter = tab.dataset.filterTab;

			tabs.forEach( ( t ) => {
				const isActive = t === tab;
				t.classList.toggle( 'is-active', isActive );
				t.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
			} );

			groups.forEach( ( group ) => {
				group.hidden = filter !== 'all' && group.dataset.filterGroup !== filter;
			} );
		} );
	} );
}
